import { render, staticRenderFns } from "./EditUSSDCodeDialog.vue?vue&type=template&id=648561bc&scoped=true&"
import script from "./EditUSSDCodeDialog.vue?vue&type=script&lang=ts&"
export * from "./EditUSSDCodeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648561bc",
  null
  
)

export default component.exports